import React, { useMemo, useState } from "react";
import ToolCard from "./ToolCard";
import { CATEGORIES, TOOLS } from "./toolsConfig";

export default function ToolsGrid({
  initialCategory = "Tous",
  showPopular = true,
  limitPopular = 3,
}) {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState(initialCategory);

  const popularTools = useMemo(() => TOOLS.filter((t) => t.popular), []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();

    return TOOLS.filter((t) => {
      const matchesCat = cat === "Tous" ? true : t.category === cat;
      if (!matchesCat) return false;

      if (!q) return true;

      const hay = [t.title, t.desc, t.category, ...(t.tags || [])]
        .join(" ")
        .toLowerCase();

      return hay.includes(q);
    });
  }, [query, cat]);

  return (
    <div>
      {/* Barre recherche + filtre */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Rechercher un outil (ex : notaire, crédit, loyer...)"
          style={{
            flex: "1 1 320px",
            padding: 12,
            borderRadius: 12,
            border: "1px solid #ddd",
          }}
        />

        <select
          value={cat}
          onChange={(e) => setCat(e.target.value)}
          style={{
            padding: 12,
            borderRadius: 12,
            border: "1px solid #ddd",
            minWidth: 180,
          }}
        >
          {CATEGORIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      {/* Quick chips */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            style={{
              padding: "8px 12px",
              borderRadius: 999,
              border: "1px solid #ddd",
              cursor: "pointer",
              fontWeight: c === cat ? 700 : 500,
            }}
          >
            {c}
          </button>
        ))}
      </div>

      {/* Populaires */}
      {showPopular && (
        <section style={{ marginTop: 18 }}>
          <h2 style={{ marginBottom: 10 }}>Les plus utilisés</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: 12,
            }}
          >
            {popularTools.slice(0, limitPopular).map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        </section>
      )}

      {/* Liste filtrée */}
      <section style={{ marginTop: 18 }}>
        <h2 style={{ marginBottom: 10 }}>
          Tous les outils {cat !== "Tous" ? `• ${cat}` : ""}
        </h2>

        {filtered.length === 0 ? (
          <p style={{ opacity: 0.75 }}>
            Aucun outil trouvé. Essaie un autre mot-clé.
          </p>
        ) : (
          <div
            className="tools-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 12,
            }}
          >
            {filtered.map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
